// extracted by mini-css-extract-plugin
export default {"avatar":"avatar__2x_9n","sm":"sm__AKfuB","md":"md__3Hdiy","lg":"lg__1yYRr","xl":"xl__hZrMN","clickable":"clickable__1TuMM"};